
import { useState, useEffect } from 'react'
import { SystemConfigService, ContactInfo } from '../services/system-config.service'

export function useContactInfo() {
    const [contactInfo, setContactInfo] = useState<ContactInfo | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function fetchInfo() {
            try {
                const info = await SystemConfigService.getContactInfo()
                setContactInfo(info)
            } catch (error) {
                console.error('Error fetching contact info:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchInfo()
    }, [])

    return { contactInfo, loading }
}
